































































































import { Component, Vue, Prop } from "vue-property-decorator";
import FileService from "@/services/FileService";
// import pdf from "vue-pdf";
import pdf from "pdfvuer";

@Component({
  components: {
    pdf
  }
})
export default class FileView extends Vue {
  private fs = new FileService();
  private tmpUrl = "";
  private title = "";
  private tags = "";
  private pubDate = "";
  private content = "";
  private uuid = "";
  private author = "";

  private numPages = 0;
  private pageNum = 1;
  private src: any;
  private showAll = false;

  private mounted() {
    this.getFile(this.$route.params.id);
  }

  private getFile(key: string) {
    this.fs.getFile(key).then(response => {
      this.title = response.data.title;
      this.tags = response.data.tags;
      this.pubDate = response.data.pub_date;
      this.uuid = response.data.uuid;
      this.author = response.data.author;

      this.content = response.data.content;
      this.tmpUrl = response.data.url;

      this.src = pdf.createLoadingTask(this.tmpUrl);

      this.src.then((resp: any) => {
        this.numPages = resp.numPages;
      });
    });
  }

  private goToTag(tag: string) {
    this.$router.push("/search?tags=" + tag);
  }

  private previousPage() {
    this.pageNum -= 1;
    if (this.pageNum <= 1) {
      this.pageNum = 1;
    }
    window.scrollTo(0, 0);
  }

  private nextPage() {
    this.pageNum += 1;
    if (this.pageNum >= this.numPages) {
      this.pageNum = this.numPages;
    }
    window.scrollTo(0, 0);
  }

  private toggleShowAll() {
    this.showAll = !this.showAll;
  }

  private editMeta() {
    this.fs
      .editMetaData(this.uuid, this.title, this.tags, this.pubDate, this.author)
      .then(response => {
        this.$bvModal.hide("modal-1");
      });
  }
}
